var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'page__patient simple-scrollbar bg-gray h-100 overflow-auto',
    {
      'page__patient--mini-variant': _vm.patientSidebarMiniVariant
    }
  ]},[_c('SettingsNavbar'),_c('Transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{staticClass:"px-15 py-6"},[(_vm.hash === '#preferences' || !_vm.hash)?_c('SettingsPreferences'):(_vm.hash.startsWith('#workspace'))?_c('SettingsWorkspaceGeneral',{attrs:{"workspaces-service":_vm.workspacesService}}):(_vm.hash === '#podomigration')?_c('SettingsPodomigration'):_vm._e()],1)]),_c('DialogWorkspaceMemberInvite',{attrs:{"workspace":_vm.currentWorkspace}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }